import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="main-container animation-fade-in component-container p-6 flex flex-col">
            {TC_TEXTS.map((item, index) => (
                <React.Fragment key={index}>
                    <h3 className="pl-6 py-6">{item.h3}</h3>
                    {item.text}
                </React.Fragment>
            ))}
        </div>
    );
};
export default PrivacyPolicy;

const TC_TEXTS = [
    {
        h3: "WE VALUE YOUR PRIVACY",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "WHAT TYPE OF INFORMATION DO WE COLLECT",
        text: (
            <span>
               Kadido.com
            </span>
        ),
    },
    {
        h3: "HOW DO WE USE THE INFORMATION WE COLLECT?",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "WHEN AND WITH WHOM DO WE SHARE THE INFORMATION WE COLLECT?",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "THIRD-PARTY SERVICES",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "HOW WE PROTECT YOUR PERSONAL INFORMATION",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "HOW LONG DO WE KEEP YOUR INFORMATION",
        text: (
            <span>
                Kadido.com
            </span>
        ),
    },
    {
        h3: "YOUR RIGHTS",
        text: (
            <span>
               Kadido.com
            </span>
        ),
    },
    {
        h3: "CROSS-BORDER DATA TRANSFER",
        text: (
            <span>
                               Kadido.com

            </span>
        ),
    },
    {
        h3: "UPDATES TO THIS PRIVACY POLICY",
        text: (
            <span>
                               Kadido.com

            </span>
        ),
    },
];
